import { UserProfile } from "../../common/services/types";
import { UserModel } from "../types";

export const getUserProfileDisplayName = (user: UserProfile) =>
    `${user.firstName || ""} ${user.lastName || ""}`.trim() ||
    user.name ||
    user.userName ||
    "";

export const sortUserProfilesByDisplayName = (users: UserProfile[]) =>
    users
        .slice()
        .sort((a, b) =>
            getUserProfileDisplayName(a).localeCompare(
                getUserProfileDisplayName(b),
                undefined,
                { sensitivity: "base" },
            ),
        );

export const sortUserModelsByUserName = (users: UserModel[]) =>
    users.slice().sort((a, b) =>
        a.userName.localeCompare(b.userName, undefined, {
            sensitivity: "base",
        }),
    );
